import { i18nRouterConfig } from "@/app/i18n/config";
import { createServerClient } from "@supabase/ssr";
import { NextResponse, type NextRequest } from "next/server";

export async function updateSession(request: NextRequest) {
  let supabaseResponse = NextResponse.next({
    request,
  });

  const supabase = createServerClient(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!,
    {
      cookies: {
        getAll() {
          return request.cookies.getAll();
        },
        setAll(cookiesToSet) {
          cookiesToSet.forEach(({ name, value, options }) =>
            request.cookies.set(name, value)
          );
          supabaseResponse = NextResponse.next({
            request,
          });
          cookiesToSet.forEach(({ name, value, options }) =>
            supabaseResponse.cookies.set(name, value, options)
          );
        },
      },
    }
  );

  const user = await supabase.auth.getUser();

  const defaultLocale = i18nRouterConfig.defaultLocale || "fr";
  if (!request.nextUrl.pathname.includes("/login") && user.error) {
    return NextResponse.redirect(
      new URL(`/${defaultLocale}/login`, request.url)
    );
  }

  if (request.nextUrl.pathname === "/" && !user.error) {
    return NextResponse.redirect(
      new URL(`/${defaultLocale}/homepage`, request.url)
    );
  }

  if (request.nextUrl.pathname.includes("/login") && !user.error) {
    return NextResponse.redirect(
      new URL(`/${defaultLocale}/homepage`, request.url)
    );
  }

  return supabaseResponse;
}
